import { useContext } from "react";
import { Offcanvas } from "react-bootstrap";
import FormHeader from "../../../Helpers/Form/FormParts/FormHeader";
import { popupcontext } from "../../../../context/Popupscontext";
import RegularFormBody from "./FormBody";
import Form from "../../../Helpers/Form/Form";

export function RegularForm({ data }) {
  const { form, isEditing } = useContext(popupcontext);
  return (
    <>
      <Form show={form}>
        <Offcanvas.Header>
          <FormHeader
            title={
              isEditing
                ? "Edit regular maintenance"
                : "Create a new regular maintenance"
            }
          />
        </Offcanvas.Header>
        <div className="H-line" />
        <Offcanvas.Body>
          <RegularFormBody isEditing={isEditing} allData={data} />
        </Offcanvas.Body>
      </Form>
    </>
  );
}
